<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="behaviours-container">
    <v-toolbar dense color="transparent" class="content-max-width elevation-0 pb-16 mt-8 mb-2">
      <v-tabs v-model="tab" background-color="transparent" class="tabs">
        <v-tab>{{ $t('tabs.customerChat') }}</v-tab>
      </v-tabs>
    </v-toolbar>
    <section class="scrollable-section">
      <v-tabs-items v-model="tab" class="tab-content content-max-width">
        <v-tab-item>
          <div class="resource-card">
            <div class="proactive-chat-title">{{ $t('proactiveChat.title') }}</div>
            <p class="proactive-chat-description" v-html="$t('proactiveChat.description')" />
            <v-btn class="primary" @click="createNewConfig">
              <v-icon>mdi-plus</v-icon>
              {{ $t('newConfiguration') }}
            </v-btn>
          </div>

          <EcsDynamicGrid ref="configurationsGrid" :cols="4" :gap="16">
            <EcsDynamicGridItem
              v-for="configuration in availableConfigurations"
              :key="configuration.id"
              :id="configuration.id"
              expanded
            >
              <template #default="{ expanded }">
                <EcsProactiveChatConfigurationPreview
                  :expanded="expanded"
                  :proactive-chat-configuration="configuration"
                />
              </template>
            </EcsDynamicGridItem>
          </EcsDynamicGrid>
        </v-tab-item>
      </v-tabs-items>
    </section>

    <EcsConfigurationWizardDialog ref="configurationWizardDialog" />
  </div>
</template>

<script>
import EcsConfigurationWizardDialog from '@/components/ecs-configuration-wizard-dialog/EcsConfigurationWizardDialog';
import EcsProactiveChatConfigurationPreview from '@/components/ecs-proactive-chat-configuration-preview/EcsProactiveChatConfigurationPreview';
import EcsDynamicGrid from '@/components/ecs-dynamic-grid/EcsDynamicGrid';
import EcsDynamicGridItem from '@/components/ecs-dynamic-grid/EcsDynamicGridItem';
import { ProactiveChatConfigurations } from '@/services';
import { mapGetters } from 'vuex';

export default {
  name: 'ContactManagement',

  components: {
    EcsProactiveChatConfigurationPreview,
    EcsConfigurationWizardDialog,
    EcsDynamicGrid,
    EcsDynamicGridItem
  },

  data() {
    return {
      isLoading: false,
      tab: 0,
      availableConfigurations: []
    };
  },

  computed: {
    ...mapGetters(['organizationId'])
  },

  mounted() {
    this.$root.$on('update-proactive-chat-configurations', this.getAllConfigurations);
  },

  beforeDestroy() {
    this.$root.$off('update-proactive-chat-configurations');
  },

  created() {
    this.getAllConfigurations();
  },

  methods: {
    getAllConfigurations() {
      ProactiveChatConfigurations.getConfigurations(this.organizationId)
        .then(data => {
          this.availableConfigurations = data;
        })
        .finally(async () => {
          await this.$nextTick();
          this.$refs.configurationsGrid.initializeGrid();
        });
    },

    createNewConfig() {
      this.$refs.configurationWizardDialog.open().then(configuration => {
        if (configuration) {
          ProactiveChatConfigurations.createConfiguration(configuration)
            .then(this.getAllConfigurations)
            .catch(() => {
              console.log('Error while creating', configuration.description);
            });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.resource-card {
  padding: 16px 0;
  border-radius: 8px;
  background-color: #0001;
}
.scrollable-section {
  height: calc(100vh - 168px);
  overflow: auto;
}
.tab-content {
  min-height: calc(100vh - 208px);
  background: transparent;
}
.content-max-width {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
.proactive-chat-title {
  font-weight: bold;
  font-size: 20px;
  margin: 20px 0 16px;
}
.proactive-chat-description {
  max-width: 65ch;
}
.delayed-start {
  max-width: 280px;
  margin-top: 32px;
}
</style>
